import { createSelector } from 'reselect'

const getState = state => state.transactions

export const getTransactions = createSelector(
  getState,
  ({ transactions }) => transactions
)

export const getTransactionsTotalCount = createSelector(
  getState,
  ({ totalTransactions }) => totalTransactions
)

export const getRecipient = createSelector(
  getState,
  ({ recipient }) => recipient
)
export const getBalance = createSelector(getState, ({ balance }) => balance)

export const getHasAwaiting = createSelector(
  getState,
  ({ hasAwaiting }) => hasAwaiting
)

export const getTransactionsPayment = createSelector(
  getState,
  ({ transactionsPayment }) => transactionsPayment
)

export const getTransactionsPaidOut = createSelector(
  getState,
  ({ transactionsPaidOut }) => transactionsPaidOut
)
